export default [
  { text: 'Наименование', value: 'name' },
  {
    text: 'Кол-во требований c параметром',
    value: 'eirs_count',
    style: 'width: 93px;',
  },
  { text: 'Тип', value: 'param_type' },
]
